
  import React from "react"
  import Component from "/Users/hlgr/Projects/Homepage/src/layouts/index.js"
  import data from "/Users/hlgr/Projects/Homepage/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js